"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireDefault(require("react"));

var _propTypes = babelHelpers.interopRequireDefault(require("prop-types"));

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
var Provider =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(Provider, _React$Component);

  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
  function Provider(props) {
    var _this;

    babelHelpers.classCallCheck(this, Provider);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Provider).call(this, props));

    if (!window.Stripe) {
      throw new Error('Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements.');
    }

    var _this$props = _this.props,
        apiKey = _this$props.apiKey,
        children = _this$props.children,
        options = babelHelpers.objectWithoutProperties(_this$props, ["apiKey", "children"]);
    /**
     * Note that this is not meant to be a generic memoization solution.
     * This is specifically a solution for `StripeProvider`s being initialized
     * and destroyed regularly (with the same set of props) when users only
     * use `StripeProvider` for the subtree that contains their checkout form.
     */

    window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
    var cacheKey = "key=".concat(apiKey, " options=").concat(JSON.stringify(options));
    _this._stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
    window.Stripe.__cachedInstances[cacheKey] = _this._stripe;
    _this._didWarn = false;
    return _this;
  }

  babelHelpers.createClass(Provider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        stripe: this._stripe
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this._didWarn && this.props.apiKey !== nextProps.apiKey && window.console && window.console.error) {
        this._didWarn = true; // eslint-disable-next-line no-console

        console.error('StripeProvider does not support changing the apiKey parameter.');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.Children.only(this.props.children);
    }
  }]);
  return Provider;
}(_react.default.Component);

exports.default = Provider;
Provider.propTypes = {
  apiKey: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};
Provider.childContextTypes = {
  stripe: _propTypes.default.object.isRequired
};
Provider.defaultProps = {
  children: null
};